import service from '../request/request'


export const queryActivities = (data) => {
    return service.request({
        url: "activity/queryActivities",
        method: 'post',
        data
    })
}



export const generateCode = (data) => {
    return service.request({
        url: `qr/wxCode`,
        method: 'post',
        data
    })
}

export const modifyPassword = (data) => {
    return service.request({
        url: 'user/updateUserPassword',
        method: 'patch',
        data
    })
}

export const activityInsert = (data) => {
    return service.request({
        url: "activity/insert",
        method: 'post',
        data
    })
}

export const activityUpdate = (data) => {
    return service.request({
        url: "activity/update",
        method: 'put',
        data
    })
}

export const activityDelete = (id) => {
    return service.request({
        url: "activity/delete/" + id,
        method: 'delete'
    })
}


//导出excel
export const excelexport = (data) => {
    return service.request({
        url: "excel/export",
        method: 'post',
        data
    })
}
//删除会议的某个嘉宾
export const deleteParticipants = (id) => {
    return service.request({
        url: "company/deleteParticipants/" + id,
        method: 'delete'
    })
}

//查看报名
export const queryAllByActivityId = (data) => {
    return service.request({
        url: "company/queryAllByActivityId",
        method: 'post',
        data
    })
}
